import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { P as PHONE_MASKS, S as SSN_MASK } from './form-input-masks.js';
import { u as updateFormValues, a as updateAddressFormValues, b as updateDateOfBirthFormValues } from './input-handlers.js';
import { d as defineCustomElement$8 } from './custom-popper2.js';
import { d as defineCustomElement$7 } from './form-control-date2.js';
import { d as defineCustomElement$6 } from './form-control-error-text2.js';
import { d as defineCustomElement$5 } from './form-control-number-masked2.js';
import { d as defineCustomElement$4 } from './form-control-select2.js';
import { d as defineCustomElement$3 } from './form-control-text2.js';
import { d as defineCustomElement$2 } from './form-control-tooltip2.js';
import { d as defineCustomElement$1 } from './identity-address-form.js';

const BusinessOwnerFormInputs = /*@__PURE__*/ proxyCustomElement(class BusinessOwnerFormInputs extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.inputHandler = (name, value) => {
            updateFormValues(this.formController, { [name]: value });
        };
        this.onAddressFormUpdate = (values) => {
            updateAddressFormValues(this.formController, Object.assign(Object.assign({}, this.formController.values.getValue().address), values));
        };
        this.ownerDefaultValue = undefined;
        this.errors = undefined;
        this.formController = undefined;
    }
    render() {
        return (h("div", { key: '00c4e99a70bdeac642774796bb6a983ad926b86d', class: "row gy-3" }, h("div", { key: '457ba67f652e7ec33909764667b76b25c0c01f75', class: "col-12 col-md-8" }, h("form-control-text", { key: '33293c6a0fc131c1db2d498f2ea8774cb9689b8e', name: "name", label: "Full Name", defaultValue: this.ownerDefaultValue.name, errorText: this.errors.name, inputHandler: this.inputHandler })), h("div", { key: '07be686fa8f43b04bd3a925e969ecede1286e651', class: "col-12 col-md-4" }, h("form-control-text", { key: 'c89285d508e0d809332f529edef3e6d3a68c4993', name: "title", label: "Title", defaultValue: this.ownerDefaultValue.title, errorText: this.errors.title, inputHandler: this.inputHandler, helpText: "Role at your business, e.g. President, CEO, Treasurer." })), h("div", { key: '76af9226fb138b2698c254ba26749b5d372ee14d', class: "col-12 col-md-6" }, h("form-control-text", { key: '37f334b0ee260501fd99845b6196a94c56fd16da', name: "email", label: "Email Address", defaultValue: this.ownerDefaultValue.email, errorText: this.errors.email, inputHandler: this.inputHandler })), h("div", { key: '3750f6f86d1bc3c3a1796a06ef4119ee188f2b56', class: "col-12 col-md-6" }, h("form-control-number-masked", { key: '283f5179e64378a7a07a654d28511558de03ca68', name: "phone", label: "Phone Number", defaultValue: this.ownerDefaultValue.phone, errorText: this.errors.phone, inputHandler: this.inputHandler, mask: PHONE_MASKS.US })), h("div", { key: '48186c6dfe8cd2a27de92db9970953e1e99340f2', class: "col-12 col-md-4" }, h("form-control-date", { key: '6d90d43875feefd24477279232a21b4ac7a7b7bc', name: "dob_full", label: "Birth Date", defaultValue: this.ownerDefaultValue.dob_full, errorText: this.errors.dob_full, inputHandler: this.inputHandler, onFormControlInput: (e) => updateDateOfBirthFormValues(e, this.formController), helpText: "Must be 18 or older." })), h("div", { key: '19b1a6fd0dd52d3d5f52cf764ff429bd26ba8cdd', class: "col-12 col-md-8" }, h("form-control-number-masked", { key: '5a7ea47c254967f0d3d546ac9949dfa3d670bc25', name: "identification_number", label: "SSN", defaultValue: this.ownerDefaultValue.identification_number, errorText: this.errors.identification_number, inputHandler: this.inputHandler, mask: SSN_MASK, helpText: "Enter your full Social Security Number. It is required for Federal OFAC check." })), h("div", { key: '59c4fcb4186d488497d66479fced70bf2dc24d89', class: "col-12" }, h("justifi-identity-address-form", { key: 'faff7bb194f9c2c2ff80193db18ab0030f34fc09', errors: this.errors.address, defaultValues: this.ownerDefaultValue.address, handleFormUpdate: this.onAddressFormUpdate }))));
    }
    ;
}, [0, "owner-form-inputs", {
        "ownerDefaultValue": [8, "owner-default-value"],
        "errors": [8],
        "formController": [16]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["owner-form-inputs", "custom-popper", "form-control-date", "form-control-error-text", "form-control-number-masked", "form-control-select", "form-control-text", "form-control-tooltip", "justifi-identity-address-form"];
    components.forEach(tagName => { switch (tagName) {
        case "owner-form-inputs":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BusinessOwnerFormInputs);
            }
            break;
        case "custom-popper":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "form-control-date":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "form-control-error-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "form-control-number-masked":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "form-control-select":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "form-control-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "form-control-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "justifi-identity-address-form":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { BusinessOwnerFormInputs as B, defineCustomElement as d };
